import { createSelector } from '@reduxjs/toolkit'

const getStateProducts = state => state.products.sku

export const getProductListBySku = createSelector(
  [getStateProducts],
  list => list
)
